<template>
  <div class="footer-all">
    <div class="ndata-footer" :style="{marginTop:marginTopHeight+'px'}">
      <el-divider class="footer-divider"/>
      <el-row>
        <el-col :span="14" :xs="24">
          <div class="footer-content">
            <div class="footer-unit">
              <span  class="footer-font">主办单位：</span>
              <div>
                <div class="footer-font">教育部第二批职业教育培训评价组织北京中民福祉教育科技有限责任公司</div>
                <div class="footer-font">恩数互联（北京）智能科技有限公司</div>
              </div>
            </div>
            <div class="footer-unit">
              <div>
                <span  class="footer-font">网站运维：恩数互联（北京）智能科技有限公司</span>
              </div>
              <div :style="{marginLeft:(!isMobile?'50px':'0px')}">
                <span  class="footer-font">技术支持：美亚联创（北京）科技有限公司</span>
              </div>
            </div>
            <div>
              <span  class="footer-font">客服电话：010-61595434/5435/5447 （工作日 8:30-17:00）</span>
            </div>
            <span class="footer-font">京ICP备19032597号-7</span>
          </div>
        </el-col>
        <el-col :span="10" :xs="24">
          <div style="margin-left: 100px">
            <el-row>
              <el-col :span="isMobile?12:6">
                <div style="text-align: center">
                  <div class="qrCodeUrl">
                    <div id="qrCodeUrl"></div>
                  </div>
                  <div style="line-height:27px;color: #ffffff;">移动学员端</div>
                </div>
              </el-col>
              <!--残联去掉-->
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath1">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath1"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle1}}</div>
<!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
<!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath2">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath2"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle2}}</div>
                  <!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
                  <!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath3">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath3"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle3}}</div>
                  <!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
                  <!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import constant from '../constant'
export default {
  props: {
    topHeight: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      marginTopHeight: 10,
      year: new Date().getFullYear(),
      dictInfo: {},
      isMobile: null,
      qrUrl: ''
    }
  },
  computed: {
    ...mapGetters(['footerList', 'siteIntro', 'websit'])
  },
  watch: {
    topHeight: {
      handler (val) {
        this.marginTopHeight = val
      },
      immediate: true
    }
  },
  created () {
    this.ismobile()
    setTimeout(() => {
      this.qrCodeGeneration()
    }, 500)
  },
  methods: {
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    // 二维码生成
    qrCodeGeneration () {
      if (this.websit) {
        this.qrUrl = this.websit.siteDomain + '/studycenter'
      }
      // 生成二维码
      this.$nextTick(function () {
        document.getElementById('qrCodeUrl').innerHTML = ''
        let qrCodeUrl = new QRCode('qrCodeUrl', {
          width: 140,
          height: 140,
          text: this.qrUrl,
          colorDark: '#000000',
          colorLight: '#fff'
        })
      })
    }
  }
}
</script>
<style lang="less" scoped >
  .footer-all{
    height: auto;
  }
  .ndata-footer{
    position: relative;
    line-height: 35px;
    /*background: linear-gradient(180deg, #4087FD 0%, #1D4FBD 100%);*/
    background: #1D4FBD;
    padding-bottom: 10px;
    /*height: 200px;*/
  }
  .footer-font{
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
  }
  .footer-left{
    display: grid;
    float: left;
    padding-top: 20px;
    padding-left: 20px;
    .footer-img{
      width: 50px;
      height: 50px;
      margin-left: 50px;
      transition: all 0.4s;
      -moz-transition:all .4s;
      -webkit-transition:all .4s;
      -o-transition:all .4s;
      background: url("../assets/155@1x.png");
      background-repeat:no-repeat;   /* 不会重复 */
      background-position: center;   /* 是为了让图片放大的时候从中部放大，不会偏移 */
      background-size: 100% 100%;
      cursor: pointer;
      /*&:hover{*/
      /*  width: 200px;*/
      /*  height: 200px;*/
      /*  background-size: 150% 150%;*/
      /*}*/
    }
    span{
      cursor: pointer;
      color: #ffffff;
    }
  }
  .footer-divider{
    position: relative;
    bottom: 7px;
    border: solid 1px #4087FD;
    background: linear-gradient(180deg, #4087FD 0%, #1D4FBD 100%);
    /*width: 99.9%;*/
  }
  /deep/.el-divider--horizontal{
    height: 2px!important;
    margin: 10px 0px!important;
  }
  .footer-content{
    margin-left: 200px;
  }
  @media (max-width: 950px) {
    .footer-content{
      margin-left: 15px;
    }
  }
  @media ( max-width : 950px){
    .footer-code{
      margin-left: 30px;
    }
  }
  .qrCodeUrl{
    width: 150px;
    height: 150px;
    background: #ffffff;
    /*margin-left: 20px;*/
  }
  #qrCodeUrl{
    padding: 5px;
  }
  .footer_img{
    width: 150px;
  }
  .footer_fon{
    line-height:25px;
    color: #ffffff
  }
  .footer-unit{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue